var React = require('react');

function RaiseHand (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M15.3,3.7v9.7c0,1.5-1.2,2.7-2.7,2.7H7.8c-0.7,0-1.4-0.3-1.9-0.8L0.7,9.9c0,0,0.8-0.8,0.9-0.8c0.1-0.1,0.3-0.2,0.5-0.2\n\t\t\t\tc0.1,0,0.3,0,0.4,0.1c0,0,2.9,1.6,2.9,1.6V2.7c0-0.6,0.4-1,1-1s1,0.4,1,1v4.7H8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v6.3h0.7V1.7\n\t\t\t\tc0-0.6,0.4-1,1-1s1,0.4,1,1v5.7h0.7V3.7c0-0.6,0.4-1,1-1S15.3,3.1,15.3,3.7z"})))));
}

RaiseHand.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = RaiseHand;

RaiseHand.default = RaiseHand;
